import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Icon } from '../../../../common/html/icon'
import { SelectCustom } from '../../../../common/selectCustom'
import { Tooltip } from '../../../../common/tooltip'
import { formatText } from '../../../../helpers/value'
import { COMPANY_NON_BANK_TYPES, COMPANY_TYPES } from '../../../../utils/common'
import { changeIndustry } from '../store/slice'
import { InputItem } from './InputItem'

const getIndustries = (industries, companyType, isDefault) => {
  if (companyType === COMPANY_TYPES.BANK) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.BANKING_INDUSTRY',
        value: COMPANY_TYPES.BANK,
        isI18n: true,
      },
    ]
  }

  if (companyType === COMPANY_NON_BANK_TYPES.NON_BANK_FIC) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.NON_BANK_FIC_INDUSTRY',
        value: COMPANY_NON_BANK_TYPES.NON_BANK_FIC,
        isI18n: true,
      },
    ]
  }

  if (companyType === COMPANY_NON_BANK_TYPES.NON_BANK_FIO) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.NON_BANK_FIO_INDUSTRY',
        value: COMPANY_NON_BANK_TYPES.NON_BANK_FIO,
        isI18n: true,
      },
    ]
  }

  if (companyType === COMPANY_NON_BANK_TYPES.NON_BANK_LEA) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.NON_BANK_LEA_INDUSTRY',
        value: COMPANY_NON_BANK_TYPES.NON_BANK_LEA,
        isI18n: true,
      },
    ]
  }

  if (companyType === COMPANY_TYPES.SECURITIES) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.SECURITIES_INDUSTRY',
        value: COMPANY_TYPES.SECURITIES,
        isI18n: true,
      },
    ]
  }

  if (companyType === COMPANY_TYPES.LIFE_INSURANCE) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.LIFE_INSURANCE_INDUSTRY',
        value: COMPANY_TYPES.LIFE_INSURANCE,
        isI18n: true,
      },
    ]
  }

  if (companyType === COMPANY_TYPES.NON_LIFE_INSURANCE) {
    return [
      {
        label: 'companyAnalysis.industryAnalysis.NON_LIFE_INSURANCE_INDUSTRY',
        value: COMPANY_TYPES.NON_LIFE_INSURANCE,
        isI18n: true,
      },
    ]
  }

  return isDefault ? industries : [{}, ...industries]
}

export const SelectCustomIndustry = ({
  data,
  vsics,
  companyType,
  keyItem,
  borderColor,
  customWidthDropdown,
  inputStyle,
  keySettingDynamicReport,
  setValueDynamicReport,
  placeholder,
  handleReset,
  isDynamicReport,
}) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState('')

  const industries = vsics
    .filter((item) => [1, 2, 3].includes(item?.level))
    .map((item) => ({
      label: [formatText(item?.code), formatText(item?.name)].join('-'),
      value: formatText(item?.id),
      isI18n: false,
    }))

  const item = getIndustries(
    industries,
    companyType,
    keyItem === 'defaultIndustry',
  ).find((item) => item.value === data)

  const disabled = [
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
    COMPANY_NON_BANK_TYPES.NON_BANK_FIC,
    COMPANY_NON_BANK_TYPES.NON_BANK_FIO,
    COMPANY_NON_BANK_TYPES.NON_BANK_LEA,
  ].includes(companyType)
  const defaultValueWithI18n = UseI18n(item?.label)
  const defaultValue = [
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
    COMPANY_NON_BANK_TYPES.NON_BANK_FIC,
    COMPANY_NON_BANK_TYPES.NON_BANK_FIO,
    COMPANY_NON_BANK_TYPES.NON_BANK_LEA,
  ].includes(companyType)
    ? defaultValueWithI18n
    : item?.label

  const chooseItem = (type) => (item) => {
    dispatch(
      changeIndustry({
        type,
        value: item?.value,
      }),
    )
    if (keySettingDynamicReport && setValueDynamicReport) {
      setValueDynamicReport(`setting.${keySettingDynamicReport}`, item?.value)
    }
  }

  const handleClickOutside = () => {
    setValue(defaultValue)
  }

  const handleOnClick = (show) => {
    if (show) {
      setValue(defaultValue)
      return
    }
    setValue('')
  }

  return (
    <SelectCustom
      id={keyItem}
      className="fw600"
      disabled={disabled}
      handleClickOutside={handleClickOutside}
      scrollId="companyAnalysis"
      renderActiveItem={() => {
        return (
          <>
            <InputItem
              defaultValue={defaultValue}
              value={value}
              setValue={setValue}
              disabled={disabled}
              keyItem={keyItem}
              style={inputStyle}
              placeholder={placeholder}
            />
            {keyItem === 'defaultIndustry' &&
            companyType === COMPANY_TYPES.CORPORATE &&
            !isDynamicReport ? (
              <Tooltip
                isI18n
                tooltipContent="companyAnalysis.industryAnalysis.RESET_DEFAULT_INDUSTRY"
              >
                <Icon
                  className="icon-reset"
                  onClick={(e) => {
                    e.stopPropagation()
                    handleReset()
                  }}
                />
              </Tooltip>
            ) : null}
          </>
        )
      }}
      customWidthDropdown={customWidthDropdown}
      data={getIndustries(
        industries,
        companyType,
        keyItem === 'defaultIndustry',
      ).filter(
        (item) =>
          !value ||
          (item?.label || '').toLowerCase().includes(value.toLowerCase()),
      )}
      style={{
        borderColor,
        width: isDynamicReport ? 345 : 552,
        borderLeft: `20px solid ${borderColor}`,
        padding: '4px 8px 4px 12px',
        marginTop: '4px',
      }}
      chooseItem={chooseItem(keyItem)}
      handleOnClick={handleOnClick}
      hiddenIcon
    />
  )
}
